var map = {
	"./android.svg": "xvic",
	"./chrome.svg": "IgAG",
	"./close.svg": "XrMM",
	"./info.svg": "HP5c",
	"./ios.svg": "oNn/",
	"./linux.svg": "+Zpq",
	"./mac.svg": "UJIZ",
	"./play.svg": "PpR5",
	"./ps4.svg": "PR58",
	"./quote.svg": "Yxwo",
	"./search.svg": "/fSE",
	"./slider-arrow-right.svg": "ihI2",
	"./windows.svg": "gSeg",
	"./xbox.svg": "wPQS"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Iu+D";